/* unplugin-vue-components disabled */import script from "./YAddValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./YAddValue.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./YAddValue.vue?vue&type=style&index=0&id=038f99dc&module=css&lang=postcss"
cssModules["css"] = style0

import exportComponent from "/root/workspace/njyx-frontend-pc_5kTN/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__